import { useNavigate } from "react-router-dom";
import "./CampaignListPage.css";
import "../components/MessagingButtons.css";
import "../components/MessagingPage.css";
import "../components/ClientSelectableTable.css";
import { useAuth } from "../../../hooks/useAuth";
import { useCampaigns } from "../../../hooks/useCampaigns";
import {
  MessageCampaign,
  MessageChannel,
  MessageType,
  MESSAGE_CHANNEL_LABELS,
  MESSAGE_TYPE_LABELS,
} from "../../../models/MessageModels";
import CampaignStatusBadge from "../components/CampaignStatusBadge";
import { formatDateTime } from "../../../utils/DateTime";
import { OrgForms } from "../../../config/forms";

const CampaignListPage = () => {
  const { user, hasPrivilege } = useAuth();
  const organizationId = user?.activeOrganization?.organizationId;
  const canCreateCampaigns = hasPrivilege(OrgForms.Messaging, "canCreate");
  const navigate = useNavigate();

  const { campaigns, loading, error, reload } = useCampaigns(organizationId);

  const renderBody = () => {
    if (loading) {
      return <div className="msg-table-empty">Loading campaigns…</div>;
    }

    if (error) {
      return (
        <div className="msg-table-empty">
          <p>{error}</p>
          <button className="msg-btn msg-btn--secondary" onClick={reload}>
            Retry
          </button>
        </div>
      );
    }

    if (campaigns.length === 0) {
      return (
        <div className="msg-table-empty">
          No campaigns yet. Click “New Campaign” to send to a group of clients.
        </div>
      );
    }

    return (
      <div className="msg-table__wrap">
        <table className="msg-table__grid msg-campaign-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Channel</th>
              <th>Total</th>
              <th>Success</th>
              <th>Failed</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.map((campaign: MessageCampaign) => (
              <tr
                key={campaign.id}
                className="msg-campaign-table__row"
                onClick={() => navigate(`/messaging/campaigns/${campaign.id}`)}
              >
                <td className="msg-campaign-table__name">
                  {campaign.name || "Untitled campaign"}
                </td>
                <td>
                  {MESSAGE_TYPE_LABELS[campaign.messageType as MessageType] ??
                    "—"}
                </td>
                <td>
                  {MESSAGE_CHANNEL_LABELS[campaign.channel as MessageChannel] ??
                    "—"}
                </td>
                <td>{campaign.totalCount}</td>
                <td className="msg-campaign-table__ok">
                  {campaign.successCount}
                </td>
                <td className="msg-campaign-table__bad">
                  {campaign.failCount}
                </td>
                <td>
                  <CampaignStatusBadge status={campaign.status} />
                </td>
                <td className="msg-campaign-table__muted">
                  {formatDateTime(campaign.createdAt)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="msg-page">
      <div className="msg-page__header">
        <div>
          <h2>Campaigns</h2>
          <p>
            Bulk messages sent to clients at{" "}
            {user?.activeOrganization?.name ?? "your organization"}.
          </p>
        </div>
        {canCreateCampaigns && (
          <button
            className="msg-btn msg-btn--primary"
            onClick={() => navigate("/messaging/campaigns/new")}
          >
            + New Campaign
          </button>
        )}
      </div>

      {renderBody()}
    </div>
  );
};

export default CampaignListPage;